import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { Campaign } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export interface PublishCampaignParams {
  id: string;
  organizationId: string;
}

export const publishCampaign = async (params: PublishCampaignParams): Promise<Campaign> => {
  return await tinctApi.campaigns.publishCampaign(params.id);
};

export const usePublishCampaign = (
  options?: Omit<
    UseMutationOptions<Campaign, ApiError, PublishCampaignParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: publishCampaign,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      queryClient.invalidateQueries({ queryKey: ['campaign', args[1].id] });
      queryClient.invalidateQueries({ queryKey: ['organization', args[1].organizationId] });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
